var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-header bg-grey fs-1-25r"},_vm._l((_vm.computedHeaders),function(cell,i){return _c('div',{key:cell.title,class:[
      'th fill-height px-2',
      cell.class,
      cell.sortable && 'pointer',
      i === 0 && 'first-cell',
      i === _vm.computedHeaders.length - 1 && 'last-cell',
      cell.value === 'details' && 'details-cell',
      cell.value === 'actions' && 'actions-cell',
      cell.value === 'name' && 'name-cell',
    ]},[_c('span',[_vm._v(" "+_vm._s(cell.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }